module.exports = __webpack_public_path__ + "static/media/LNC-aggregates-on-sand-2-crop.0ea3ec6f.jpg";